import { useTranslation } from "react-i18next";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

/** How many of a known number of things have been dealt with so far. */
export interface ProgressCount {
  done: number;
  total: number;
}

export type ProgressBarProps = ProgressCount;

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

/** A determinate bar with an "n of m" caption, for work that goes through a known number of items. */
export function ProgressBar({ done, total }: ProgressBarProps) {
  const { t } = useTranslation();
  return (
    <Root>
      <LinearProgress
        variant="determinate"
        value={total > 0 ? (done / total) * 100 : 0}
        aria-label="Progress"
      />
      <Typography variant="caption" color="text.secondary">
        {t("common.progressCount", { done, total })}
      </Typography>
    </Root>
  );
}
